import React from "react";
import s from './description.module.scss';
import locales from '../../../content.json';

export const Description = () => {

  return(
    <div className={s.description}>
      <h3>
        {locales[window.userLang].payment_text_32}
      </h3>
      <p>
        {locales[window.userLang].payment_text_33}
      </p>
    </div>
  )
}